import Banner from "../../components/ElectricalRepair/Banner/Banner";
import Benefits from "../../components/ElectricalRepair/Benefits/Benefits";
import Cards from "../../components/ElectricalRepair/Cards/Cards";
import Conditioning from "../../components/ElectricalRepair/Conditioning/Conditioning";
import List from "../../components/ElectricalRepair/List/List";
import Steps from "../../components/ElectricalRepair/Steps/Steps";
import HelmetLayout from "../../components/GlobalComponents/HelmetLayout";

const ElectricalRepair = () => {
    return (
        <HelmetLayout
            name="Electrical Repair"
            title="Ard Altaamir: Electrical Repair & Maintenance "
            description="Certified electrical repair and maintenance services from Ard Altaamir. Safe, reliable, and energy-efficient solutions for every property."
            route="services/electrical-repair"
        >
            <Banner />
            <List />
            <Conditioning />
            <Steps />
            <Benefits />
            <Cards />
        </HelmetLayout>
    );
};

export default ElectricalRepair;
